<template>
  <DialogProfileItemTemplate
    :disabled="isCurrentMember"
    :class="{ active: isCurrentMember }"
  >
    <template #image>
      <component :is="tag" class="button" @click="handleClickSwitch(member)">
        <ImgLoad effect="none" alt="avatar" :src="member.avatarUrl" />
      </component>
    </template>
    <template #label>
      <icon v-if="showWarning" name="warning" size="2rem" color="primary" />
      <span class="label-name">{{ member.name }}</span>
    </template>
  </DialogProfileItemTemplate>
</template>
<script setup lang="ts">
import DialogProfileNotASubscriber from '~/components/dialog/profile/DialogProfileNotASubscriber.vue';
import DialogProfilNotAllowedToSwitch from '~/components/dialog/profile/DialogProfilNotAllowedToSwitch.vue';
const context = useContextStore();
interface Props {
  member: FamilyMember;
}
const props = defineProps({
  member: null
});
const profile = useProfileStore();
const dialog = useDialogStore();
const familySwitchMember = useFamilySwitchMember();

const { shareResultsWithFamily } = useFamilyMember(props.member);

const isCurrentMember = computed(
  () => props.member.memberId === context.memberId
);
const showWarning = computed(() => {
  if (isCurrentMember.value) return false;
  if (!profile.isASubscriber) return true;
  if (!shareResultsWithFamily.value) return true;
  return false;
});
const tag = computed(() => (isCurrentMember.value ? 'span' : 'button'));

const isSwitchableToMember = computed(() =>
  familySwitchMember.canSwitchToMember(props.member)
);

const handleClickSwitch = (member: FamilyMember) => {
  if (isCurrentMember.value) return;
  if (!profile.isASubscriber) {
    dialog.close();
    dialog.open(DialogProfileNotASubscriber, {
      level: DialogLevel.Info,
      member,
    });
  } else if (!isSwitchableToMember.value) {
    dialog.close();
    dialog.open(DialogProfilNotAllowedToSwitch, {
      level: DialogLevel.Info,
      member,
    });
  } else {
    familySwitchMember.switchToMember(member);
  }
};
</script>
<style lang="scss" scoped>
.icon {
  position: relative;
  top: -0.2rem;
  left: -0.2rem;
  color: var(--color_secondary);
}
.button {
  transition: transform 300ms $ease-out-back;
  &:hover,
  &:focus {
    transform: scale(1.1);
  }
  &.disabled {
    transform: none;
    transition: none;
  }
}
.active {
  .button {
    transform: scale(1);
    transition: none;
    border: 0.7rem solid var(--color_secondary_darker);
    border-radius: 50%;
  }
  .label-name {
    color: var(--color_secondary_darker);
    font-weight: 800;
  }
}
</style>
